import { define, auto, Record } from 'type-r'
import { restfulIO } from 'type-r/endpoints/restful'
import { store } from '../models/store.js'
import TableComponent from './table.js'
import tmpl_fnma from './fnma.pug'

@define
export default class FnmaComponent extends TableComponent {
    static endpoint = restfulIO('/json')

    initialize() {
        this.listenTo(store, "change:currdt", this.refresh);
    }

    parse(data?:any) {
        data = super.parse(data);
        if (data?.extras) {
            this.trigger("extras", data.extras);
            delete data.extras;
        }
        if (data?.data) {
            data = data.data;
        }
        return data;
    }

    async refresh() {
        await this.fetch()
        this.render()
    }

    fetch(opts?: any) {
        return super.fetch({params: {fj: store.token, type: 'fnma', ...opts?.params}})
    }

    render() {
        let config = this.config;
        let header = this.header;
        let rows = this.rows;
        let selCpn = store.selCpn;
        let html = tmpl_fnma({ name, config, header, rows, startCpn: store.startCpn, selCpn });
        $(this.el).html(html);
        $(this.el).find("#fnma-rows li").on('click', function() {
            const idx = parseInt($(this).data('idx') as string);
            $(this).closest('#fnma-rows').find('li').css('background', '');
            $(this).css('background', '#d4edda');
            store.selIdx = idx;
            store.selCpn = rows[idx][0];
        });
    }
}
